import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e25b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "events"
}

import { computed } from 'vue';
import { useInfo, useHome } from '@/store';
import { storeToRefs } from 'pinia';
import EventsSlide from './EventsSlide.vue';
import EventsYear from './EventsYear.vue';
import EventsTimeline from './EventsTimeline.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Events',
  setup(__props) {

_useCssVars(_ctx => ({
  "4ba83310": (_unref(bg).pc),
  "02f0df3f": (_unref(bg).mobile),
  "ef1795c2": (_unref(mask).pc[0]),
  "1159db10": (_unref(mask).mobile[0]),
  "ef179584": (_unref(mask).pc[1]),
  "1159db2f": (_unref(mask).mobile[1])
}))

const { getImg } = useInfo();
const { annualTimeline, currentBg } = storeToRefs(useHome());
const bg = computed(() => ({
  pc: `url(${currentBg.value.bgLandscape})`,
  mobile: `url(${currentBg.value.bgPortrait})`,
}));
const mask = computed(() => ({
  pc: [
    `url(${getImg('home_pc_around_mask')})`,
    `url(${getImg('home_pc_bottom_mask')})`,
  ],
  mobile: [
    `url(${getImg('home_mobile_around_mask')})`,
    `url(${getImg('home_mobile_bottom_mask')})`,
  ],
}));

return (_ctx: any,_cache: any) => {
  return (_unref(annualTimeline).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(EventsSlide),
        _createVNode(EventsTimeline),
        _createVNode(EventsYear)
      ]))
    : _createCommentVNode("", true)
}
}

})